import Vue from 'vue'
import VuePaginate from 'vue-paginate'

Vue.use(VuePaginate)
